import * as Yup from 'yup';

import {
  currentPasswordSchema,
  newPasswordConfirmationSchema,
  newPasswordSchema,
} from './new-password.schema';

export const PasswordChangeSchema = Yup.object().shape({
  newPassword: newPasswordSchema.required('Choisissez un nouveau mot de passe'),
  newPasswordConfirmation: newPasswordConfirmationSchema,
  currentPassword: currentPasswordSchema,
});
